/**
 * A barra de cima do celular (#880): o botão da gaveta e o nome da tela. Só
 * existe com a tela estreita; no desktop o menu fica sempre ao lado.
 */

import type { ReactNode } from 'react';
import type { Trilho } from '../model/usar-trilho';

export function BarraMovel({
  trilho,
  titulo,
}: {
  readonly trilho: Trilho;
  readonly titulo: string;
}): ReactNode {
  const { estreita, gavetaAberta, definirGavetaAberta, botaoDaGaveta } = trilho;
  return (
    <>
      {estreita && (
        <div className="casca__barra">
          <button
            ref={botaoDaGaveta}
            type="button"
            className="casca__barra-menu"
            aria-label="Menu"
            aria-expanded={gavetaAberta}
            aria-controls="menu-principal"
            onClick={() => definirGavetaAberta((v) => !v)}
          >
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              strokeWidth={1.7}
              strokeLinecap="round"
              aria-hidden="true"
            >
              <path d="M3 5.5h14M3 10h14M3 14.5h14" />
            </svg>
          </button>
          {/*
        Em Configurações a barra diz também QUAL seção — "Configurações ·
        Pessoas". Sem isso ela dizia "Configurações" nas oito, e no
        celular, onde o submenu vive dentro da gaveta, era a única pista
        de onde a pessoa caiu.
      */}
          <span className="casca__barra-titulo">{titulo}</span>
        </div>
      )}
    </>
  );
}
